






import Vue from 'vue'

import '@/assets/styles.css'

export default Vue.extend({
  name: 'App',

  components: {
  },

});
